import React from 'react'
import SALink from 'components/SALink'
import { NewThisWeekImage, TitleBanner } from '../../styles'
import { getDate, hasNumber } from '../../../helpers/helperFunctions'
type Props = {
  collectionTitle: string
  collectionUrl: string
  imageUrl: string
  index: string
}
export default (props: Props): React.ReactElement<React.ComponentProps<any>, any> => {
  const { imageUrl, collectionTitle, collectionUrl, index } = props
  const firstTileImage = imageUrl.replace('-25', '-7')
  return (
    <SALink itemProp='url' href={collectionUrl} title={`Go to Collection ${collectionTitle}`}>
      <NewThisWeekImage
        image={index === `collection-public-1` ? firstTileImage : imageUrl}
        alt={`Collection ${collectionTitle}`}
        itemProp='contentURL'
        data-type={index === `collection-public-1` ? 'firstArtWorkItem' : 'artworkItem'}
      >
        <TitleBanner>
          <span itemProp='name' data-type='newThisWeekTitle'>
            {/* split collection name from collection title to display on separate line
            and add special styling */}
            {`The Week of`}{' '}
          </span>
          <span data-type='newThisWeekDate'>
            {hasNumber(collectionTitle) ? getDate(collectionTitle) : collectionTitle}
          </span>
        </TitleBanner>
      </NewThisWeekImage>
    </SALink>
  )
}